import { FC } from 'react';

import noOp from 'utils/noop';

import { CopySnippetModal } from './modals/CopySnippetModal';
import { DeleteSnippetModal } from './modals/DeleteSnippetModal';
import { SaveSnippetModal } from './modals/SaveSnippetModal';

import { useSnippetModals } from '../hooks/useSnippetModals';
import { useSnippetQueryContext } from '../context/SnippetQueryContext';
import { ModalIntent } from '../constants';
import { GraphQLSnippet } from '../types';

type Props = {
  handleCopy?: () => void;
  handlePublish?: () => void;
  intent?: ModalIntent;
  onCopySuccess?: (updatedSnippet: GraphQLSnippet) => void;
  onDeleteSuccess?: () => void;
  snippet?: GraphQLSnippet;
};

export const SnippetModals: FC<React.PropsWithChildren<Props>> = ({
  handleCopy = noOp,
  handlePublish = noOp,
  intent,
  onCopySuccess = noOp,
  onDeleteSuccess = noOp,
  snippet,
}: Props) => {
  const modals = useSnippetModals();
  const { selectedSnippet } = useSnippetQueryContext();
  const targetSnippet = snippet || selectedSnippet;

  return (
    <>
      {modals.copy.isShown && targetSnippet && (
        <CopySnippetModal
          closeModal={() => {
            modals.copy.toggle(false);
          }}
          intent={intent}
          onCopySuccess={onCopySuccess}
          snippet={targetSnippet}
        />
      )}

      {modals.delete.isShown && targetSnippet && (
        <DeleteSnippetModal
          closeModal={() => {
            modals.delete.toggle(false);
          }}
          intent={intent}
          onDeleteSuccess={onDeleteSuccess}
          snippet={targetSnippet}
        />
      )}

      {modals.save.isShown && (
        <SaveSnippetModal
          closeModal={() => {
            modals.save.toggle(false);
          }}
          handleCopy={handleCopy}
          handlePublish={handlePublish}
        />
      )}
    </>
  );
};
